import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { response } from "@share/type";
import { environment } from "environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ProjectsService {
  http: HttpClient = inject(HttpClient);
  GET_PROJECTS_URL = environment.oldApi + "/projects/";


  getProjects() {
    return this.http.get<any[]>(this.GET_PROJECTS_URL);
  }

}